/* eslint-disable max-len */
import React from 'react';
import { Button, Row, Col, Table } from 'reactstrap';

const SinCambios = <span className="text-muted">Sin cambios</span>;
const SinDato = <span className="text-muted">Sin dato</span>;

interface AccountData {
  nombre: string
  apellido: string
  tipo_doc: string
  nro_doc: string
  matricula: string
  email: string
  celular_codigo: string
  celular_numero: string
  domicilio_particular: Domicilio
  domicilio_legal: Domicilio
}

interface Domicilio {
  calle: string
  numero: string
  piso: string
  depto: string
  cp: string
  localidad_id: string
  localidad: string
  partido_id: string
  partido: string
  telefono_codigo: string
  telefono_numero: string
}

interface NewAccountData {
  id: number;
  matriculate_id: number;
  state_id: number;

  email: string;
  celular_codigo: string;
  celular_numero: string;

  particular_calle: string;
  particular_numero: number;
  particular_piso: string;
  particular_depto: string;
  particular_cp: string;
  particular_localidad_id: number;
  particular_localidad: string;
  particular_partido_id: number;
  particular_partido: string;
  particular_telefono_codigo: string;
  particular_telefono_numero: string;

  legal_calle: string;
  legal_numero: number;
  legal_piso: string;
  legal_depto: string;
  legal_cp: string;
  legal_localidad_id: number;
  legal_localidad: string;
  legal_partido_id: number;
  legal_partido: string;
  legal_telefono_codigo: string;
  legal_telefono_numero: string;

  rejection_text: string | null;
  created_at: string | null;
  resolved_at: string | null;
  deleted_at: string | null;
  user_id: number | null;
}

interface Props {
  data: {
    original: AccountData
    new: NewAccountData;
  };
  isLoading: boolean;
  onAccept: () => void;
  onReject: () => void;
}

function AccountForm(props: Props) {
  const { data, isLoading, onAccept, onReject } = props;

  const accept = () => {
    if (!onAccept) {
      return;
    }

    onAccept();
  };

  const reject = () => {
    if (!onReject) {
      return;
    }

    onReject();
  };

  return (
    <>
      {
        data && !isLoading
          ? <Table className="mb-4">
              <thead>
                <tr>
                  <th></th>
                  <th>Valor original</th>
                  <th>Nuevo valor</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>Correo Electrónico</th>
                  <td>{ data.original.email !== null ? data.original.email : SinDato }</td>
                  <td>{
                    data.original.email?.trim() !== data.new.email?.trim()
                      ? data.new.email
                      : SinCambios
                  }</td>
                </tr>
                <tr>
                  <th>Cód. Área Celular</th>
                  <td>{ data.original.celular_codigo !== null ? data.original.celular_codigo : SinDato }</td>
                  <td>{
                    data.original.celular_codigo?.trim() !== data.new.celular_codigo?.trim()
                      ? data.new.celular_codigo
                      : SinCambios
                  }</td>
                </tr>
                <tr>
                  <th>Nro. Celular</th>
                  <td>{ data.original.celular_numero !== null ? data.original.celular_numero : SinDato }</td>
                  <td>{
                    data.original.celular_numero?.trim() !== data.new.celular_numero?.trim()
                      ? data.new.celular_numero
                      : SinCambios
                  }</td>
                </tr>
                <tr>
                  <th colSpan={3}><h3>Domicilio Particular</h3></th>
                </tr>
                <tr>
                  <th>Calle</th>
                  <td>{ data.original.domicilio_particular.calle !== null ? data.original.domicilio_particular.calle : SinDato }</td>
                  <td>{
                    data.original.domicilio_particular.calle?.trim() !== data.new.particular_calle?.trim()
                      ? data.new.particular_calle
                      : SinCambios
                  }</td>
                </tr>
                <tr>
                  <th>Número</th>
                  <td>{ data.original.domicilio_particular.numero !== null ? data.original.domicilio_particular.numero : SinDato }</td>
                  <td>
                    {
                      data.new.particular_numero &&
                      data.original.domicilio_particular.numero !== data.new.particular_numero.toString()
                        ? data.new.particular_numero.toString()
                        : SinCambios
                    }
                  </td>
                </tr>
                <tr>
                  <th>Piso</th>
                  <td>{ data.original.domicilio_particular.piso !== null ? data.original.domicilio_particular.piso : SinDato }</td>
                  <td>{
                    data.original.domicilio_particular.piso?.trim() !== data.new.particular_piso?.trim()
                      ? data.new.particular_piso
                      : SinCambios
                  }</td>
                </tr>
                <tr>
                  <th>Departamento</th>
                  <td>{ data.original.domicilio_particular.depto !== null ? data.original.domicilio_particular.depto : SinDato }</td>
                  <td>{
                    data.original.domicilio_particular.depto?.trim() !== data.new.particular_depto?.trim()
                      ? data.new.particular_depto
                      : SinCambios
                  }</td>
                </tr>
                <tr>
                  <th>Código Postal</th>
                  <td>{ data.original.domicilio_particular.cp !== null ? data.original.domicilio_particular.cp : SinDato }</td>
                  <td>{
                    data.original.domicilio_particular.cp?.trim() !== data.new.particular_cp?.trim()
                      ? data.new.particular_cp
                      : SinCambios
                  }</td>
                </tr>
                <tr>
                  <th>Localidad</th>
                  <td>{ data.original.domicilio_particular.localidad !== null ? data.original.domicilio_particular.localidad : SinDato }</td>
                  <td>{
                    data.original.domicilio_particular.localidad?.trim() !== data.new.particular_localidad?.trim()
                      ? data.new.particular_localidad
                      : SinCambios
                  }</td>
                </tr>
                <tr>
                  <th>Partido</th>
                  <td>{ data.original.domicilio_particular.partido }</td>
                  <td>{
                    data.original.domicilio_particular.partido?.trim() !== data.new.particular_partido?.trim()
                      ? data.new.particular_partido
                      : SinCambios
                  }</td>
                </tr>
                <tr>
                  <th>Cód. Área Teléfono</th>
                  <td>{ data.original.domicilio_particular.telefono_codigo !== null ? data.original.domicilio_particular.telefono_codigo : SinDato }</td>
                  <td>{
                    data.original.domicilio_particular.telefono_codigo?.trim() !== data.new.particular_telefono_codigo?.trim()
                      ? data.new.particular_telefono_codigo
                      : SinCambios
                  }</td>
                </tr>
                <tr>
                  <th>Nro. Teléfono</th>
                  <td>{ data.original.domicilio_particular.telefono_numero !== null ? data.original.domicilio_particular.telefono_numero : SinDato }</td>
                  <td>{
                    data.original.domicilio_particular.telefono_numero?.trim() !== data.new.particular_telefono_numero?.trim()
                      ? data.new.particular_telefono_numero
                      : SinCambios
                  }</td>
                </tr>
                <tr>
                  <th colSpan={3}><h3>Domicilio Legal</h3></th>
                </tr>
                <tr>
                  <th>Calle</th>
                  <td>{ data.original.domicilio_legal.calle !== null ? data.original.domicilio_legal.calle : SinDato }</td>
                  <td>{
                    data.original.domicilio_legal.calle?.trim() !== data.new.legal_calle?.trim()
                      ? data.new.legal_calle
                      : SinCambios
                  }</td>
                </tr>
                <tr>
                  <th>Número</th>
                  <td>{ data.original.domicilio_legal.numero !== null ? data.original.domicilio_legal.numero : SinDato }</td>
                  <td>
                    {
                      data.new.legal_numero &&
                      data.original.domicilio_legal.numero !== data.new.legal_numero.toString()
                        ? data.new.legal_numero.toString()
                        : SinCambios
                    }
                  </td>
                </tr>
                <tr>
                  <th>Piso</th>
                  <td>{ data.original.domicilio_legal.piso !== null ? data.original.domicilio_legal.piso : SinDato }</td>
                  <td>{
                    data.original.domicilio_legal.piso?.trim() !== data.new.legal_piso?.trim()
                      ? data.new.legal_piso
                      : SinCambios
                  }</td>
                </tr>
                <tr>
                  <th>Departamento</th>
                  <td>{ data.original.domicilio_legal.depto !== null ? data.original.domicilio_legal.depto : SinDato }</td>
                  <td>{
                    data.original.domicilio_legal.depto?.trim() !== data.new.legal_depto?.trim()
                      ? data.new.legal_depto
                      : SinCambios
                  }</td>
                </tr>
                <tr>
                  <th>Código Postal</th>
                  <td>{ data.original.domicilio_legal.cp !== null ? data.original.domicilio_legal.cp : SinDato }</td>
                  <td>{
                    data.original.domicilio_legal.cp?.trim() !== data.new.legal_cp?.trim()
                      ? data.new.legal_cp
                      : SinCambios
                  }</td>
                </tr>
                <tr>
                  <th>Localidad</th>
                  <td>{ data.original.domicilio_legal.localidad !== null ? data.original.domicilio_legal.localidad : SinDato }</td>
                  <td>{
                    data.original.domicilio_legal.localidad?.trim() !== data.new.legal_localidad?.trim()
                      ? data.new.legal_localidad
                      : SinCambios
                  }</td>
                </tr>
                <tr>
                  <th>Partido</th>
                  <td>{ data.original.domicilio_legal.partido }</td>
                  <td>{
                    data.original.domicilio_legal.partido?.trim() !== data.new.legal_partido?.trim()
                      ? data.new.legal_partido
                      : SinCambios
                  }</td>
                </tr>
                <tr>
                  <th>Cód. Área Teléfono</th>
                  <td>{ data.original.domicilio_legal.telefono_codigo !== null ? data.original.domicilio_legal.telefono_codigo : SinDato }</td>
                  <td>{
                    data.original.domicilio_legal.telefono_codigo?.trim() !== data.new.legal_telefono_codigo?.trim()
                      ? data.new.legal_telefono_codigo
                      : SinCambios
                  }</td>
                </tr>
                <tr>
                  <th>Nro. Teléfono</th>
                  <td>{ data.original.domicilio_legal.telefono_numero !== null ? data.original.domicilio_legal.telefono_numero : SinDato }</td>
                  <td>{
                    data.original.domicilio_legal.telefono_numero?.trim() !== data.new.legal_telefono_numero?.trim()
                      ? data.new.legal_telefono_numero
                      : SinCambios
                  }</td>
                </tr>
              </tbody>
            </Table>
          : null
      }
      {
        onAccept || onReject
          ? <Row>
              <Col className="text-center">
                <Button color="danger" onClick={ reject } disabled={ isLoading || !onReject }>Rechazar</Button>
                <Button color="success" onClick={ accept } disabled={ isLoading || !onAccept }>Aceptar</Button>
              </Col>
            </Row>
          : null
      }
    </>
  );
}

export default AccountForm;
